import { RootState } from 'redux/rootReducer'

export const CONTRACT_AUTH_FLOW_RELATED_REDUCERS: Array<keyof RootState> = [
  'contractAuthEmployerLaborers',
  'createContractAuthRequestStatus',
  'laborerPhoneForContractAuthStatus',
  'createContractAuthRequest',
]
